import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function PropertyFilter() {

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    locality: "",
    buyPropertyType: "flats",
    rentPropertyType: "house",
    commercialPropertyType: "office-space",
    colivingPropertyType: "office-space",
    plotsPropertyType: "office-space",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e, tab) => {
    e.preventDefault();

    navigate("/PropertyListHome", { state: { type: tab,
      subCategory: formData.buyPropertyType,
      budget: null,
      loc: formData.locality, } });
  };


  const propertyTypes = {
    buy: {
      id: "buy",
      label: "Buy",
      type: "sell",
      options: [
        { value: "flats", label: "Flats" },
        { value: "houses", label: "Houses" },
        { value: "villa", label: "Villas" },
        { value: "plots", label: "Plots" },
        { value: "Studio Apartment", label: "Studio Apartment" },
        { value: "offices", label: "Offices" },
        { value: "shops", label: "Shops" }
      ]
    },
    rent: {
      id: "rent",
      label: "Rent",
      type: "rent",
      options: [
        { value: "house", label: "House" },
        { value: "apartment", label: "Apartment" },
        { value: "condo", label: "Villa" }
      ]
    },
    commercial: {
      id: "commercial",
      label: "Commercial",
      type: "commercial",
      options: [
        { value: "office-space", label: "Office Space" },
        { value: "retail-space", label: "Retail Space" },
        { value: "industrial-space", label: "Industrial Space" }
      ]
    },
    coliving: {
      id: "coliving",
      label: "PG/Co Living",
      type: "coliving",
      options: [
        { value: "office-space", label: "Office Space" },
        { value: "retail-space", label: "Retail Space" },
        { value: "industrial-space", label: "Industrial Space" }
      ]
    },
    plots: {
      id: "plots",
      label: "Plots",
      type: "plots",
      options: [
        { value: "office-space", label: "Office Space" },
        { value: "retail-space", label: "Retail Space" },
        { value: "industrial-space", label: "Industrial Space" }
      ]
    }
  };

  return (
    <div
    className="position-relative" 
      style={{
        backgroundImage: `url('./images/illustration/home-bg-Image.png')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: "63vh",
      }}
    >
       <div className="position-absolute bottom-0 start-0 end-0 mb-5">
        <ul
          className="nav live-work-nav nav-pills justify-content-center"
          id="propertyTabs"
          role="tablist"
          style={{ paddingTop: "14%" }}
        >
          {["Buy", "Rent", "Commercial", "Plots"].map(
            (tab, index) => (
              <li className="nav-item" key={index}>
                <a
                  className={`nav-link buy-btn-head ${
                    index === 0 ? "active" : ""
                  }`}
                  id={`${tab.toLowerCase()}-tab`}
                  data-bs-toggle="pill"
                  href={`#${tab.toLowerCase()}`}
                  role="tab"
                  aria-controls={tab.toLowerCase()}
                  aria-selected={index === 0}
                >
                  {tab}
                </a>
              </li>
            )
          )}
        </ul>

        {/* Tab Content */}
      <div className="tab-content" id="propertyTabsContent">
  {Object.values(propertyTypes).map((tab, index) => (
    <div
      key={tab.id}
      className={`tab-pane fade ${index === 0 ? 'show active' : ''}`}
      id={tab.id}
      role="tabpanel"
      aria-labelledby={`${tab.id}-tab`}
    >
      <form className="d-flex gap-2" onSubmit={(e) => handleSubmit(e, tab.type)}>
        <input
          className="form-control "
          type="text"
          name="locality"
          placeholder="Type Locality Or Project/Society or Builder"
          value={formData.locality}
          onChange={handleChange}
        />
        <select
          className="form-select"
          name={`${tab.id}PropertyType`}
          value={formData[`${tab.id}PropertyType`]}
          onChange={handleChange}
        >
          {tab.options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button className="btn btn-primary" type="submit">
          <i className="bi bi-search"></i> Search
        </button>
      </form>
    </div>
  ))}
</div>
      </div>
    </div>
  );
}

export default PropertyFilter;